export const VIDEO_MAIN_OPEN_ADVANCED_FILTERS = 'VIDEO_MAIN_OPEN_ADVANCED_FILTERS';
